import moment from 'moment'

export default class Token {
  constructor ({
    access_token = null,
    expires_in = null,
    refresh_token = null,
    token_type = null,
    expires_epoch = null,
    grant_type = null
  }) {
    this.access_token = access_token
    this.refresh_token = refresh_token
    this.token_type = token_type
    this.grant_type = grant_type

    if (expires_epoch !== null) {
      this.expires_epoch = expires_epoch
    } else if (typeof expires_in === 'number') {
      this.expires_epoch = moment().add(expires_in, 'seconds').unix()
    }
  }

  isExpired () {
    return moment().unix() > this.expires_epoch
  }

  static toJson (token) {
    return JSON.stringify({ ...token })
  }

  static fromJson (json) {
    return new Token(JSON.parse(json))
  }
}
